import Header from '../../components/Header'
import Footer from '../../components/Footer'
import About from '../../components/About'

function AboutCourse() {
    return (
        <div>
            <Header></Header>
            <About></About>
            <Footer></Footer>
        </div>
    )
}

export default AboutCourse